<template>
  <div class="app">
    <div class="d-flex h-100 justify-content-center align-items-center">
      <div class="mx-auto app-login-box col-md-8">
        <div class="mb-3 d-flex align-items-center justify-content-center">
          <img v-show="temLogoClienteNaSessao" :src="logoCliente" alt="" width="200" class="tenant-logo brand-image mt-1 ml-3 mr-3"/>
          <img alt="logo" :src="obterLogo" width="200" class="office-logo brand-image img-fluid">
        </div>

        <div class="modal-dialog w-100 mx-auto">
          <div class="modal-content" v-if="retorno.sucesso">
            <div class="modal-body">
              <div class="d-flex flex-column align-items-center justify-content-center">
                <h4 class="font-weight-bold">Senha redefinida com sucesso!</h4>

                <p class="textos mt-3">
                  Sua senha foi alterada com sucesso. Agora você já pode acessar sua conta com a nova senha.
                </p>

                <router-link
                  :to="{name: 'login'}"
                  :disabled="flags.efetuandoRequisicao"
                  class="small mt-3">
                  <span>Voltar para o login</span>
                </router-link>
              </div>
            </div>
          </div>

          <div class="modal-content" v-else>
            <div class="modal-body">
              <div class="modal-title">
                <div class="d-flex justify-content-center mb-3">
                  <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12 d-flex justify-content-between flex-row flex-wrap">
                    <h5 class="text-left">
                      Redefinir Senha
                    </h5>

                    <div>
                      <router-link :to="{name: 'login'}" :disabled="flags.efetuandoRequisicao" class="small">
                        <span>Voltar para o login</span>
                      </router-link>
                    </div>
                  </div>
                </div>

                <div class="avisoDanger mensagemAlerta" v-show="retorno.mensagem">
                  {{ retorno.mensagem }}
                </div>

                <div v-if="flags.efetuandoRequisicao" class="divLoginSpinner mb-3">
                  <span class="avisoDanger">Por favor, aguarde...</span>
                  <b-spinner class="ml-2" variant="danger"></b-spinner>
                </div>
              </div>

              <div v-if="recuperacaoPeloSso" id="acesso-sso" class="mt-2">
                <b-button variant="btn btn-secondary btn-sm botaoLogin botaoSso" @click="irParaLoginPreambulo">
                  <img :src="iconePreambulo" alt="" class="icone-sso">
                  Ir para o login Preâmbulo
                </b-button>
              </div>

              <form v-else>
                <div class="input-group mb-3">
                  <input
                    type="password"
                    @keyup="eventoLoginTeclaEnter"
                    autocomplete="new-password"
                    name="nova_senha"
                    id="nova_senha"
                    class="form-control campoSemBordaDireita corBordaCampo placeholder"
                    v-model="dadosFormulario.nova_senha"
                    placeholder="Nova senha...">

                  <div class="input-group-append">
                    <div class="input-group-text fundoBotaoIcone corBordaCampo">
                      <i class="fa fa-lock fa-cor"></i>
                    </div>
                  </div>
                </div>

                <div class="avisoDanger text-left mb-2">
                  {{ retorno.listaDeErros['f_new_password'] }}
                </div>

                <div class="input-group mb-3">
                  <input
                    type="password"
                    @keyup="eventoLoginTeclaEnter"
                    autocomplete="new-password"
                    name="confirmacao_senha"
                    id="confirmacao_senha"
                    class="form-control campoSemBordaDireita corBordaCampo placeholder"
                    v-model="dadosFormulario.confirmacao_senha"
                    placeholder="Confirme a nova senha...">

                  <div class="input-group-append">
                    <div class="input-group-text fundoBotaoIcone corBordaCampo">
                      <i class="fa fa-lock fa-cor"></i>
                    </div>
                  </div>
                </div>

                <div class="avisoDanger text-left mb-2">
                  {{ retorno.listaDeErros['f_confirm_password'] }}
                </div>

                <div id="acesso" class="mt-2">
                  <b-button
                    variant="btn btn-secondary btn-sm botaoLogin"
                    :disabled="flags.efetuandoRequisicao"
                    @click="redefinirSenha">
                    Redefinir Senha
                  </b-button>

                  <p class="textos text-center mt-2">
                    Informe uma senha segura para finalizar a recuperação de acesso.
                  </p>
                </div>
              </form>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import RedefinicaoSenhaOffice from './js/redefinicaoSenhaOffice.js'
export default RedefinicaoSenhaOffice
</script>

<style scoped>
@import "./scss/login.scss";
</style>
